import { render, staticRenderFns } from "./VideoAutoPlayPage.vue?vue&type=template&id=1f26f8f6&"
import script from "./VideoAutoPlayPage.vue?vue&type=script&lang=ts&"
export * from "./VideoAutoPlayPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports